import React, { useCallback, useEffect, useState } from 'react'
import { ManageContent, ManageCountdown, ManageHeaderBottom, ManageHeaderContent, ManageHeaderWrapper, ManageImage, ManageInfo, ManagePageWrapper, ManageBottomItem, ManageTitle, PageWrapper } from './styled'
import { Redirect, RouteComponentProps } from 'react-router-dom'
import { NFTStakeList } from '../../../data/NFTStakeList'
import { INFTStakeList } from '../../../models/INFTStake'
import {
	useEarnedAmount,
	useNFTStakeExitAll,
	useNFTStakeGetReward,
	useNFTStakeRewardRate,
	useNFTStakeTokensOfAccount,
	useNFTStakeTotalStaked
} from '../../../../../hooks/useNFTStake'
import { getAccountCollectionItems } from '../../../../../services/NFTMarketPlace/Graphquery'
import { useActiveWeb3React } from '../../../../../hooks'
import { INFTCollectionItems } from '../../../models/INFTCollectionItems'
import StakeCard from './StakeCard'
import { ApprovalState } from '../../../../../hooks/useApproveCallback'
import { useApproveAllCallbackFromNFT } from '../../../../../hooks/useNFTMarketPlace'
import UnstakeCard from './UstakeCard'
import usePrevious from '../../../../../hooks/usePrevious'
import { CountUp } from 'use-count-up'
import NFTButton from '../../../newComponents/NFTButton'

/*@ts-ignore */
import FlipCountdown from '@rumess/react-flip-countdown';
import NFTTabs from '../../../newComponents/NFTTabs'
import Scrollbar from '../../../components/Scrollbar'
import { ListItemsContainer } from '../../../newComponents/NFTList/styled'
import Empty from '../../../newComponents/Empty'
import Loader from '../../../../../components/Loader'
import { loadNFTLikeCounts } from '../../../data/useNFTLikeCount'

export default function NFTStakeManage({
	match: {
		params: { contractAddress }
	}
}: RouteComponentProps<{ contractAddress?: string }>) {
	const { account } = useActiveWeb3React()
	const foundStakingItem = NFTStakeList.find(
		(item: INFTStakeList) => item.contractAddress.toLowerCase() === contractAddress?.toLowerCase()
	)
	const foundContractAddress = foundStakingItem?.contractAddress ?? NFTStakeList[0].contractAddress
	const foundTokenAddress = foundStakingItem?.collection.tokenAddress ?? NFTStakeList[0].collection.tokenAddress

	const [onCollectionList, setCollectionList] = useState<INFTCollectionItems[]>([])
	const [activeTab, setActiveTab] = useState('unstake')
	const [approveState, approveCallback] = useApproveAllCallbackFromNFT(
		foundTokenAddress,
		account,
		foundContractAddress,
		'NFT Staking Approved'
	)
	const [approvePending, setApprovePending] = useState<ApprovalState>(ApprovalState.NOT_APPROVED)
	const [claimPending, setClaimPending] = useState<boolean>(false)
	const [exitAllPending, setExitAllPending] = useState<boolean>(false)
	const [isLoading, setIsLoading] = useState<boolean>(true)

	const tokensOfAccountList: number[] = useNFTStakeTokensOfAccount(foundContractAddress, account)
	const totalStakedToken = useNFTStakeTotalStaked(foundContractAddress)
	const rewardRate = useNFTStakeRewardRate(foundContractAddress, totalStakedToken, tokensOfAccountList.length)

	const earnedAmount = useEarnedAmount(foundContractAddress, account)
	const [NFTStakeClaimReward] = useNFTStakeGetReward(foundContractAddress)
	const [NFTStakeExitAll] = useNFTStakeExitAll(foundContractAddress)

	const countUpAmount = earnedAmount?.toFixed(6) ?? '0'
	const countUpAmountPrevious = usePrevious(countUpAmount) ?? '0'

	function tabChange(tabKey: string) {
		return () => {
			setActiveTab(tabKey)
		}
	}

	const getAccountCollectionItem = useCallback(() => {
		setIsLoading(true);
		getAccountCollectionItems(
			account,
			foundStakingItem?.collection.tokenAddress
		).then((response: INFTCollectionItems[]) => {
			setCollectionList(response);
			setIsLoading(false);
			if (foundStakingItem) {
				loadNFTLikeCounts(response.map((r: INFTCollectionItems) => ({ collectionAddress: foundStakingItem.collection.tokenAddress.toLowerCase(), tokenID: +r.tokenID })));
			}
		})
	}, [account, foundStakingItem, setCollectionList])

	function claimReward() {
		if (!claimPending) {
			setClaimPending(true)
			NFTStakeClaimReward()
				.then(() => {
					setClaimPending(false)
				})
				.catch(() => {
					setClaimPending(false)
				})
		}
	}

	function exitAllNFT() {
		if (!exitAllPending) {
			setExitAllPending(true)
			NFTStakeExitAll()
				.then(() => {
					setExitAllPending(false)
				})
				.catch(() => {
					setExitAllPending(false)
				})
		}
	}

	useEffect(() => {
		getAccountCollectionItem()
	}, [account, tokensOfAccountList.length])

	useEffect(() => {
		if (foundStakingItem) {
			loadNFTLikeCounts(tokensOfAccountList.map((r: number) => ({ collectionAddress: foundStakingItem.collection.tokenAddress.toLowerCase(), tokenID: r })));
		}
	}, [account, foundStakingItem, tokensOfAccountList]);

	const approveFunc = useCallback(() => {
		if (approveState !== ApprovalState.APPROVED) {
			setApprovePending(ApprovalState.PENDING)
			approveCallback()
				.then((response: any) => {
					if (response === false) {
						setApprovePending(ApprovalState.NOT_APPROVED)
					} else {
						setApprovePending(ApprovalState.APPROVED)
					}
				})
				.catch(() => {
					setApprovePending(ApprovalState.NOT_APPROVED)
				})
		}
	}, [approveState]);

	const renderTabContent = (key: string) => {
		if (key === 'avaliableItems') {
			if (onCollectionList.length === 0) return (<Empty size='large' />)
			if (isLoading) return (<Loader size='50px' />)
			return (
				<ListItemsContainer>
					{onCollectionList.map((item: INFTCollectionItems) => (
						<StakeCard
							key={`${item.tokenID}_STAKE_CARD`}
							data={item}
							account={account ?? ''}
							stakingData={foundStakingItem}
							approveState={approveState === ApprovalState.APPROVED ? approveState : approvePending}
							approve={approveFunc}
						/>
					))}
				</ListItemsContainer>
			)
		} else {
			if (tokensOfAccountList.length === 0) return (<Empty size='large' />)
			return (
				<ListItemsContainer>
					{tokensOfAccountList.map((tokenId: number) => (
						<div style={{ margin: '1rem' }}>
							<UnstakeCard
								key={`${tokenId}_UNSTAKE_CARD`}
								tokenId={tokenId}
								stakingData={foundStakingItem}
								account={account ?? ''}
							/>
						</div>
					))}
				</ListItemsContainer>
			)
		}
	}
	return (
		<Scrollbar>
			<ManagePageWrapper>
				{foundStakingItem === undefined && <Redirect to="/nft-stake" />}
				{foundStakingItem && (
					<>
						<ManageHeaderWrapper>
							<ManageHeaderContent>
								<ManageImage>
									<img src={foundStakingItem.collection.logo} alt={foundStakingItem.collection?.name} height={150} width={150} />
								</ManageImage>
								<ManageInfo>
									<ManageTitle>
										Stake: {foundStakingItem.collection.name}
									</ManageTitle>
									<div>
										{`Total Staked: ${totalStakedToken?.multiply((1000000000000000000).toString())?.toFixed(0, { groupSeparator: ',' }) ?? 0} / ${foundStakingItem.maxSupply}`}
									</div>
									<div>
										{`Pool Rate: ${rewardRate.totalRewardRate
											?.multiply((60 * 60 * 24).toString())
											?.toSignificant(4, { groupSeparator: ',' }) ?? 0} ${foundStakingItem.earnToken.symbol} / day`}
									</div>
									<div>
										{`You Staked: ${tokensOfAccountList.length}`}
									</div>

								</ManageInfo>
								{foundStakingItem.finishAt && (
									<ManageCountdown>
										<FlipCountdown
											hideYear
											hideMonth
											//endAtZero
											size={"small"}
											titlePosition={"bottom"}
											theme={'light'} // Options (Default: dark): dark, light.
											endAt={foundStakingItem.finishAt} // Date/Time
										><span>Stake Period Finished</span></FlipCountdown>
									</ManageCountdown>
								)}
							</ManageHeaderContent>
							<ManageHeaderBottom>
								<ManageBottomItem>
									<div>Reward Rate</div>
									<span>{rewardRate.rewardRate
										?.multiply((60 * 60 * 24).toString())
										?.toSignificant(4, { groupSeparator: ',' }) ?? 0}{' '}
										{foundStakingItem.earnToken.symbol} / day</span>
								</ManageBottomItem>
								<ManageBottomItem>
									<div>
										Your unclaimed {foundStakingItem.earnToken.symbol}
									</div>
									<span>
										<CountUp
											key={countUpAmount}
											isCounting
											decimalPlaces={4}
											start={parseFloat(countUpAmountPrevious)}
											end={parseFloat(countUpAmount)}
											thousandsSeparator={','}
											duration={1}
										/>
									</span>
								</ManageBottomItem>
								<div style={{ width: 200 }}>
									<NFTButton loading={exitAllPending} disabled={exitAllPending} onClick={exitAllNFT}>Withdraw</NFTButton>
								</div>
								<div style={{ width: 200 }}>
									<NFTButton loading={claimPending} disabled={claimPending} onClick={claimReward}>Claim Reward</NFTButton>
								</div>
							</ManageHeaderBottom>
						</ManageHeaderWrapper>
						<ManageContent>
							<NFTTabs tabs={[{ key: 'avaliableItems', name: 'Avaliable NFTs' }, { key: 'stakedItems', name: 'Staked NFTs' }]} renderTabContent={renderTabContent} noScrollbar />
						</ManageContent>
					</>
				)}
			</ManagePageWrapper >
		</Scrollbar>
	)

	// return (
	// 	<PageWrapper>
	// 		{foundStakingItem === undefined && <Redirect to="/nft-stake" />}
	// 		{foundStakingItem && (
	// 			<>
	// 				<div className="stakeManageHead">
	// 					<div className="stakeManageLogoWrapper">
	// 						<div className="stakeManageLogo">
	// 							<img src={foundStakingItem.collection.logo} />
	// 						</div>
	// 					</div>
	// 					<div className="stakeManageTitle">{foundStakingItem.collection.name} Staking</div>
	// 					<div className="stakingManageInfo">
	// 						<div className="stakingManageInfoItem">
	// 							<div className="stakingManageInfoItemText">Total Staked</div>
	// 							<div className="stakingManageInfoItemValue">
	// 								{totalStakedToken?.multiply((1000000000000000000).toString())?.toFixed(0, { groupSeparator: ',' }) ??
	// 									0}{' '}
	// 								/ {foundStakingItem.maxSupply}
	// 							</div>
	// 						</div>
	// 						<div className="stakingManageInfoItem">
	// 							<div className="stakingManageInfoItemText">Pool Rate</div>
	// 							<div className="stakingManageInfoItemValue">
	// 								{rewardRate.totalRewardRate
	// 									?.multiply((60 * 60 * 24).toString())
	// 									?.toSignificant(4, { groupSeparator: ',' }) ?? 0}{' '}
	// 								{foundStakingItem.earnToken.symbol} / day
	// 							</div>
	// 						</div>
	// 						{foundStakingItem.finishAt && (
	// 							<div className="stakingManageInfoItem">
	// 								<div className="stakingManageInfoItemText">Finish At</div>
	// 								<div className="stakingManageInfoItemValue">
	// 									<Countdown
	// 										date={foundStakingItem.finishAt}
	// 										renderer={({ days, hours, minutes, seconds }) => {
	// 											if (days === 0 && hours === 0 && minutes === 0 && seconds === 0) {
	// 												return 'Stake Period Finished'
	// 											} else {
	// 												const daysToHour = days * 24 + hours
	// 												return (
	// 													<div className="countDown">
	// 														{daysToHour < 10 ? `0${daysToHour}` : daysToHour}:{minutes < 10 ? `0${minutes}` : minutes}
	// 														:{seconds < 10 ? `0${seconds}` : seconds} left
	// 													</div>
	// 												)
	// 											}
	// 										}}
	// 									/>
	// 								</div>
	// 							</div>
	// 						)}
	// 					</div>
	// 				</div>
	// 				<div className="stakeManageBody">
	// 					<div className="stakeMangeRate">
	// 						<div className="stakeAccountBalance">
	// 							<div className="stakeAccountBalanceTitle">Your Staked Collection</div>
	// 							<div className="stakedAccountBalanceValue">
	// 								<div className="stakedAccountBalanceInfo">{tokensOfAccountList.length}</div>
	// 								<div className="stakedAccountBalanceName">{foundStakingItem.collection.name}</div>
	// 							</div>
	// 						</div>
	// 						<div className="stakeAccountRate">
	// 							<div className="stakeAccountRateTitle">Your unclaimed {foundStakingItem.earnToken.symbol}</div>
	// 							<div className="stakeAccountRateValue">
	// 								<div className="stakeAccountRateUnclaimed">
	// 									<CountUp
	// 										key={countUpAmount}
	// 										isCounting
	// 										decimalPlaces={4}
	// 										start={parseFloat(countUpAmountPrevious)}
	// 										end={parseFloat(countUpAmount)}
	// 										thousandsSeparator={','}
	// 										duration={1}
	// 									/>
	// 								</div>
	// 								<div className="stakeAccountRateInfo">
	// 									{rewardRate.rewardRate
	// 										?.multiply((60 * 60 * 24).toString())
	// 										?.toSignificant(4, { groupSeparator: ',' }) ?? 0}{' '}
	// 									{foundStakingItem.earnToken.symbol} / day
	// 								</div>
	// 							</div>
	// 						</div>
	// 					</div>
	// 					<div className="stakeWidthDrawAll">
	// 						<NFTButton
	// 							disable={claimPending}
	// 							onClick={claimReward}
	// 							className={claimPending ? 'stakeWidthDrawAllButton pending' : 'stakeWidthDrawAllButton'}
	// 							text="Claim"
	// 						/>
	// 						<NFTButton
	// 							disable={exitAllPending}
	// 							onClick={exitAllNFT}
	// 							className={exitAllPending ? 'stakeWidthDrawAllButton pending' : 'stakeWidthDrawAllButton'}
	// 							text="Withdraw All & Claim"
	// 						/>
	// 					</div>
	// 					<div className="stakedSection">
	// 						<div className="stakedMenu">
	// 							<ul>
	// 								<li onClick={tabChange('unstake')} className={activeTab === 'unstake' ? 'active' : ''}>
	// 									Unstaked Items ({onCollectionList.length})
	// 								</li>
	// 								<li onClick={tabChange('stake')} className={activeTab === 'stake' ? 'active' : ''}>
	// 									Staked Items ({tokensOfAccountList.length})
	// 								</li>
	// 							</ul>
	// 						</div>
	// 						<div className="stakedList">{renderNFTItems()}</div>
	// 					</div>
	// 				</div>
	// 			</>
	// 		)}
	// 	</PageWrapper>
	// )
}
